const filters      = document.querySelector( '.content-heading-form__paid-status' );
const dropdownPaid = document.querySelector( '.content-heading-form__dropdown--paid' );
const overlay      = document.querySelector( '.content-heading-form__overlay' );

const filter          = document.querySelector( '.content-heading-form__filters--invoice' );
const dropdown        = document.querySelector( '.content-heading-form__dropdown--invoice' );

const radioButtons = document.querySelectorAll('.dropdown__label .radio');

radioButtons.forEach( (radio) => {
	radio.addEventListener('click', (e) => {
		radioButtons.forEach( (radio) => {
			radio.classList.remove('radio--active');
		});

		radio.classList.add('radio--active');
	} );
} );


if ( filters && dropdownPaid && overlay ) {
	filters.addEventListener( 'click', ( e ) => {
		if ( !e.target.classList.contains( 'content-heading-form__paid-status' ) ) {
			return
		}

		if ( filters.classList.contains( 'open' ) ) {
			filters.classList.remove( 'open' );
			closeMenu();
		} else {
			if ( filter.classList.contains( 'open' ) ) {
				filter.classList.remove( 'open' );
			}

			filters.classList.add( 'open' );
			openMenu();
		}
	} );

	filter.addEventListener( 'click', ( e ) => {
		if ( !e.target.classList.contains( 'content-heading-form__filters--invoice' ) ) {
			return
		}

		if ( filter.classList.contains( 'open' ) ) {
			filter.classList.remove( 'open' );

			closeMenuFilter();
		} else {
			if ( filters.classList.contains( 'open' ) ) {
				filters.classList.remove( 'open' );
			}

			filter.classList.add( 'open' );
			openMenuFilter();
		}
	} );

	overlay.addEventListener( 'click', ( e ) => {
		if ( filters.classList.contains( 'open' ) ) {
			filters.classList.remove( 'open' );
			closeMenu();
		}

		if ( filter.classList.contains( 'open' ) ) {
			filter.classList.remove( 'open' );
			closeMenuFilter();
		}

	} );

	window.addEventListener( 'resize', () => {
		if ( filters.classList.contains( 'open' ) ) {
			filters.classList.remove( 'open' );
			closeMenu();
		}

		if ( filter.classList.contains( 'open' ) ) {
			filter.classList.remove( 'open' );
			closeMenuFilter();
		}

	} );
}

const openMenu = () => {
	if ( dropdown.classList.contains( 'open' ) ) {
		dropdown.classList.remove( 'open' );
	}

	dropdownPaid.classList.add( 'open' );
	overlay.classList.add( 'show' );
}

const closeMenu = () => {
	dropdownPaid.classList.remove( 'open' );
	overlay.classList.remove( 'show' );
}

const openMenuFilter = () => {
	if ( dropdownPaid.classList.contains( 'open' ) ) {
		dropdownPaid.classList.remove( 'open' );
	}

	dropdown.classList.add( 'open' );
	overlay.classList.add( 'show' );
}

const closeMenuFilter = () => {
	dropdown.classList.remove( 'open' );
	overlay.classList.remove( 'show' );
}